import * as React from 'react';

import $ from 'jquery';

/**
 * React component wrapper for selectize.js
 */
import PropTypes from 'prop-types';
import 'selectize';

// eslint-disable-line no-restricted-syntax
import 'css!bundles/vendor/selectize/styles/selectize.bootstrap3.css';
import 'css!bundles/vendor/selectize/styles/selectize.css';

// eslint-disable-line no-restricted-syntax

// TODO: Get rid of this component and use react-selectize: https://github.com/furqanZafar/react-selectize
type Props = {
  options: Record<string, unknown>;
  placeholder: string;
  disabled?: boolean;
  focus?: boolean;
  clearInput?: boolean;
};

class SelectizeComponent extends React.Component<Props> {
  static propTypes = {
    options: PropTypes.object.isRequired,
    placeholder: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    focus: PropTypes.bool,
    clearInput: PropTypes.bool,
  };

  componentDidMount() {
    const { disabled, focus, options } = this.props;

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'select' does not exist on type 'Selectiz... Remove this comment to see the full error message
    const { select } = this;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectize' does not exist on type 'JQuer... Remove this comment to see the full error message
    const selectizeElement = $(select).selectize(options);

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectizeInstance' does not exist on typ... Remove this comment to see the full error message
    this.selectizeInstance = selectizeElement[0].selectize;

    if (disabled) {
      selectizeElement[0].selectize.disable();
    }

    if (options.selected) {
      // Silently change value to selected
      selectizeElement[0].selectize.setValue(options.selected, true);
    }

    if (focus) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectizeInstance' does not exist on typ... Remove this comment to see the full error message
      this.selectizeInstance.focus();
    }
  }

  shouldComponentUpdate(nextProps: $TSFixMe, nextState: $TSFixMe) {
    const { options, disabled, clearInput } = this.props;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'select' does not exist on type 'Selectiz... Remove this comment to see the full error message
    const select = this.select;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectize' does not exist on type 'JQuer... Remove this comment to see the full error message
    const selectizeElement = $(select).selectize(options);

    if (nextProps.disabled !== disabled) {
      if (nextProps.disabled) {
        selectizeElement[0].selectize.disable();
      } else {
        selectizeElement[0].selectize.enable();
      }

      return true;
    }

    if (nextProps.clearInput !== clearInput) {
      if (nextProps.clearInput) {
        selectizeElement[0].selectize.clear(true);
      }

      return true;
    }

    if (nextProps.options.selected && nextProps.options.selected !== options.selected) {
      selectizeElement[0].selectize.setValue(nextProps.options.selected, true);
    }

    return false;
  }

  render() {
    return (
      <div className="rc-Selectize">
        <select
          ref={(select) => {
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'select' does not exist on type 'Selectiz... Remove this comment to see the full error message
            this.select = select;
          }}
        />
      </div>
    );
  }
}

export default SelectizeComponent;
